export const lang = {
  name: "名字",
};
